import {Component, Input, OnInit} from "@angular/core";
import {RefundData} from "../mapper/refund-data";


@Component({
    selector: 'db-refund-info',
    templateUrl: './refund-info.component.html',
    styleUrls: ['./refund-info.component.scss'],
    standalone: false
})
export class RefundInfoComponent implements OnInit {

  @Input() refund: RefundData;
  constructor() {
  }

  ngOnInit() {
  }
}
